class CompanyBenefitModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'CompanyBenefitModal';

    $scope.companyBenefit = {};

    $scope.cancel = function () {
      $scope.companyBenefit = {};
      $uibModalInstance.cancel();
    };

    $scope.opened = {};
    $scope.datePickerOptions = {
      formatYear: 'yy',
      startingDay: 1,
      showWeeks: false
    };

    $scope.expirationDatePickerOptions = {
      formatYear: 'yy',
      startingDay: 1,
      showWeeks: false,
      minDate: $scope.companyBenefit.startDate
    };

    $scope.datePickerFormat = 'MMM dd, yyyy';

    $scope.open = function($event, elementOpened) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.opened[elementOpened] = !$scope.opened[elementOpened];
    };


    $scope.createCompanyBenefit = function() {

      $http.post($rootScope.apiHost+"/api/admin/companies/1/benefits", $scope.companyBenefit, {withCredentials: true}).then(function (success) {
        $uibModalInstance.success();
      }, function (failure) {
        $scope.errorMessage = failure.data.message;
      });
    }

    $scope.cancel = function() {
      $uibModalInstance.cancel();
    }

    $scope.missingRequiredValues = function() {
      let allValuesPresent = true

        // $scope.companyBenefit.name &&
        //       $scope.companyBenefit.description &&
        //       $scope.companyBenefit.endDate &&
        //       $scope.companyBenefit.startDate &&
        //       $scope.companyBenefit.rate;

      return !allValuesPresent;
    }

  }





}

export default CompanyBenefitModalController;



// WEBPACK FOOTER //
// ./client/common/modals/companyBenefitModal/companyBenefitModal.controller.js